// Call plugin.
import * as eventTypes from '../eventTypes'
import * as actionTypes from '../actionTypes'
import { OPERATIONS, OP_TRANSITIONS } from '../constants'

// Handlers.
import { callOperationHandler, callEventHandler, stateChangeHandler } from './handlers'

// Helpers
import { cloneDeep } from 'lodash/fp'

const callEvents = {}
/*
  "Complex" actions are:
    - DIRECT_TRANSFER
    - DIRECT_TRANSFER_FINISH

    - CONSULTATIVE_TRANSFER
    - PENDING_CONSULTATIVE_TRANSFER
    - CONSULTATIVE_TRANSFER_FINISH

    - JOIN
    - PENDING_JOIN
    - JOIN_FINISH
 */

callEvents[actionTypes.DIRECT_TRANSFER] = (action, params) => {
  return callOperationHandler(action, {
    ...params,
    operation: OPERATIONS.DIRECT_TRANSFER,
    transition: OP_TRANSITIONS.START,
    isLocal: true
  })
}

callEvents[actionTypes.DIRECT_TRANSFER_FINISH] = (action, params) => {
  return [
    callOperationHandler(action, {
      ...params,
      operation: OPERATIONS.DIRECT_TRANSFER,
      isLocal: true,
      transition: OP_TRANSITIONS.FINISH
    }),
    stateChangeHandler(action, params)
  ]
}

// -----

callEvents[actionTypes.CONSULTATIVE_TRANSFER] = (action, params) => {
  return callOperationHandler(action, {
    ...params,
    operation: OPERATIONS.CONSULTATIVE_TRANSFER,
    transition: OP_TRANSITIONS.START,
    isLocal: true
  })
}

callEvents[actionTypes.PENDING_CONSULTATIVE_TRANSFER] = (action, params) => {
  const otherCallAction = cloneDeep(action)
  otherCallAction.payload.id = action.payload.otherCallId
  return [
    callOperationHandler(action, {
      ...params,
      operation: OPERATIONS.CONSULTATIVE_TRANSFER,
      transition: OP_TRANSITIONS.UPDATE,
      isLocal: true
    }),
    callOperationHandler(otherCallAction, {
      ...params,
      operation: OPERATIONS.CONSULTATIVE_TRANSFER,
      transition: OP_TRANSITIONS.UPDATE,
      isLocal: true
    })
  ]
}

callEvents[actionTypes.CONSULTATIVE_TRANSFER_FINISH] = (action, params) => {
  return [
    callOperationHandler(action, {
      ...params,
      operation: OPERATIONS.CONSULTATIVE_TRANSFER,
      isLocal: true,
      transition: OP_TRANSITIONS.FINISH
    }),
    stateChangeHandler(action, params)
  ]
}

// -----

callEvents[actionTypes.JOIN] = (action, params) => {
  return callOperationHandler(action, {
    ...params,
    operation: OPERATIONS.JOIN,
    transition: OP_TRANSITIONS.START,
    isLocal: true
  })
}

callEvents[actionTypes.PENDING_JOIN] = (action, params) => {
  const operationEvents = action.payload.usedCallIds.map(callId => {
    const newAction = cloneDeep(action)
    newAction.payload.id = callId
    return callOperationHandler(newAction, {
      ...params,
      operation: OPERATIONS.JOIN,
      transition: OP_TRANSITIONS.UPDATE,
      isLocal: true
    })
  })
  operationEvents.push(callEventHandler(eventTypes.CALL_JOIN, action))
  return operationEvents
}

callEvents[actionTypes.JOIN_FINISH] = (action, params) => {
  return [
    callOperationHandler(action, {
      ...params,
      operation: OPERATIONS.JOIN,
      isLocal: true,
      transition: OP_TRANSITIONS.FINISH
    }),
    stateChangeHandler(action, params)
  ]
}

export default callEvents
